<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Dokumen
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="createDocument">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="table.filterType == 'type'" v-model="table.filterValue" :options="table.filterValueTypeOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-select v-else-if="table.filterType == 'fiducia'" v-model="table.filterValue" :options="table.filterValueFiduciaOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-select v-else-if="table.filterType == 'roya'" v-model="table.filterValue" :options="table.filterValueRoyaOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['HO'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(fiducia)="row">
                <b-form-checkbox v-model="row.item.fiducia"></b-form-checkbox>
              </template>
              <template #cell(roya)="row">
                <b-form-checkbox v-model="row.item.roya"></b-form-checkbox>
              </template>
              <template #cell(apht)="row">
                <b-form-checkbox v-model="row.item.apht"></b-form-checkbox>
              </template>
              <template #cell(action)="row">
                <!-- <CButton size="sm" color="warning" style="color: white;" @click="editDocument(row.item.id)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-pencil" />
                </CButton>  -->
                <CButton size="sm" color="primary" style="color: white;" class="mr-2 custom-button-action" @click="saveDocument(row.index)" :disabled="row.item.isSaving">
                  <b-spinner small type="grow" v-if="row.item.isSaving" /> 
                  {{ row.item.isSaving ? 'Sedang diproses...' : 'Save' }}
                </CButton>
                <template v-if="row.item.deletable">
                  <CButton size="sm" color="danger" style="color: white;" @click="showDeleteModal(row.item.id, row.item.repoGroup, row.item.display, row.item.type, row.item.fiducia, row.item.roya)" class="btn-icon mr-2 custom-button-action">
                    Delete
                  </CButton> 
                </template>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="showDeleteDocumentModal" :centered="true">
      <div slot="header"><h5>Konfirmasi Delete Document</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menghapus Document berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            ID
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.id }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Group
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.repoGroup }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Name
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.display }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Tipe
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.type }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Fiducia
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.fiducia == true ? 'true' : 'false' }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Roya
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteDocument.roya == true ? 'true' : 'false' }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showDeleteDocumentModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmDeleteDocument" :disabled="isLoading.deleteDocument">
          <b-spinner small type="grow" v-if="isLoading.deleteDocument" /> 
          {{ isLoading.deleteDocument ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showCreateModal" :centered="true">
        <div slot="header"><h5>Create Document</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="ID"
                label-for="document-id"
                :state="document.id.isValid"
              >
                <b-form-input
                  v-model="document.id.value"
                  :state="document.id.isValid"
                  placeholder="ID"
                  id="document-id"
                  maxlength="10"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Group"
                label-for="document-group"
                :state="document.group.isValid"
              >
                <b-form-input
                  v-model="document.group.value"
                  :state="document.group.isValid"
                  placeholder="Group"
                  id="document-group"
                  maxlength="10"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Nama"
                label-for="document-name"
                :state="document.name.isValid"
              >
                <b-form-input
                  v-model="document.name.value"
                  :state="document.name.isValid"
                  placeholder="Nama"
                  id="document-name"
                  maxlength="256"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tipe"
                label-for="document-type"
                :state="document.type.isValid"
              >
                <b-form-select 
                  v-model="document.type.value" 
                  :options="table.filterValueTypeOptions" 
                  :state="document.type.isValid"
                  id="document-type">
                </b-form-select>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Fiducia"
                label-for="document-fiducia"
                :state="document.fiducia.isValid"
              >
                <b-form-select 
                  v-model="document.fiducia.value" 
                  :options="table.filterValueFiduciaOptions" 
                  :state="document.fiducia.isValid"
                  id="document-fiducia">
                </b-form-select>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Roya"
                label-for="document-roya"
                :state="document.roya.isValid"
              >
                <b-form-select 
                  v-model="document.roya.value" 
                  :options="table.filterValueRoyaOptions" 
                  :state="document.roya.isValid"
                  id="document-roya">
                </b-form-select>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="APHT"
                label-for="document-apht"
                :state="document.apht.isValid"
              >
                <b-form-select 
                  v-model="document.apht.value" 
                  :options="table.filterValueRoyaOptions" 
                  :state="document.apht.isValid"
                  id="document-apht">
                </b-form-select>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateModal = false">Cancel</CButton> 
          <CButton class="ml-2" color="primary" type="submit" @click="createItem" :disabled="isLoading.createItem">
            <b-spinner small type="grow" v-if="isLoading.createItem" /> 
            {{ isLoading.createItem ? 'Loading...' : 'Save' }}
          </CButton>
        </div>
      </CModal>
    </CForm>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigDocumentList',
  data() {
    return {
      showCreateModal: false,
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "id", label: "ID", sortable: true},
          {key: "repoGroup", label: "Group", sortable: true},
          {key: "display", label: "Nama", sortable: true},
          {key: "type", label: "Tipe", sortable: true},
          {key: "fiducia", label: "Fiducia", sortable: true},
          {key: "roya", label: "Roya", sortable: true},
          {key: "apht", label: "APHT", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],

        items: [],

        filterType: "id",
        filterOptions: [
          { value: "id", text: "ID" },
          { value: "repoGroup", text: "Group" },
          { value: "display", text: "Nama" },
          { value: "type", text: "Tipe" },
          { value: "fiducia", text: "Fiducia" },
          { value: "roya", text: "Roya" },
        ],
        filterValue: "",
        filterValueTypeOptions: [
          { value: "image", text: "image" },
          { value: "file", text: "file" },
        ],
        filterValueFiduciaOptions: [
          { value: true, text: "true" },
          { value: false, text: "false" },
        ],
        filterValueRoyaOptions: [
          { value: true, text: "true" },
          { value: false, text: "false" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      isLoading: {
        deleteDocument: false,
        createItem: false,
      },

      showDeleteDocumentModal: false,
      deleteDocument: {
        id: 0,
        repoGroup: '',
        display: '',
        type: '',
        fiducia: '',
        roya: '',
      },

      document: {
        id: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "id"
        },
        group: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "group"
        },
        name: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "display"
        },
        type: {
          value: 'image',
          isValid: null,
          isRequired: true,
          options: [
            { value: "image", text: "Image" },
            { value: "file", text: "File" },
          ],
          payloadKey: "type"
        },
        fiducia: {
          value: true,
          isValid: null,
          isRequired: true,
          options: [
            { value: true, text: "true" },
            { value: false, text: "false" },
          ],
          payloadKey: "fiducia"
        },
        roya: {
          value: true,
          isValid: null,
          isRequired: true,
          options: [
            { value: true, text: "true" },
            { value: false, text: "false" },
          ],
          payloadKey: "roya"
        },
        apht: {
          value: true,
          isValid: null,
          isRequired: true,
          options: [
            { value: true, text: "true" },
            { value: false, text: "false" },
          ],
          payloadKey: "apht"
        },
      }
    }
  },
  methods: {

    createItem(event) {
      event.preventDefault()

      this.isLoading.createItem = true
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.document)){
        if (data.isRequired && this.$helper.isEmpty(data.value)) {
          isFormValid = false
          data.isValid = false
        } else{
          data.isValid = null
          obj[data.payloadKey] = data.value
        }
      }

      obj = {
        ...obj,
        repoDesc: ''
      }

      if (isFormValid) {
        let postUrl = '/documentTemplate/add/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.resetDocument()
              this.getTableItems(this.table.currentPage)
              this.$helper.toastSuccess(this, "Create Document Berhasil! " + (response.data.reason ? response.data.reason : ""))
              this.showCreateModal = false
            } else{
              this.$helper.toastError(this, "Create Document Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Document Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Create Document Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.createItem = false
          })
        }
      } else{
        this.isLoading.createItem = false
      }
    },

    saveDocument(index) {

      let obj = {
        id: this.table.items[index].id,
        fiducia: this.table.items[index].fiducia,
        roya: this.table.items[index].roya,
        apht: this.table.items[index].apht,
        display: null,
        group: null,
        repoDesc: null,
        type: null
      }

      let postUrl = '/documentTemplate/edit/'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.table.items[index].isSaving = true
        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            // this.$helper.toastSuccess(this, "Create Document Berhasil! " + (response.data.reason ? response.data.reason : ""))
            // this.clearInput()
            this.$helper.toastSuccess(this, "Edit Document Berhasil! " + (response.data.reason ? response.data.reason : ""))
          }
          else{
            this.$helper.toastError(this, "Edit Document Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit Document Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Edit Document Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.items[index].isSaving = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    resetDocument() {
      this.document.id.value = ''
      this.document.id.isValid = null
      this.document.group.value = ''
      this.document.group.isValid = null
      this.document.name.value = ''
      this.document.name.isValid = null
      this.document.type.value = 'image'
      this.document.type.isValid = null
      this.document.fiducia.value = true
      this.document.fiducia.isValid = null
      this.document.roya.value = true
      this.document.roya.isValid = null
    },

    createDocument() {
      this.resetDocument()
      this.showCreateModal = true
    },

    // editDocument(id) {
    //   this.$router.push({ name: 'Config Document Edit', params: { documentId: id } })
    // },

    showDeleteModal(id, group, name, type, fiducia, roya) {
      this.deleteDocument.id = id
      this.deleteDocument.repoGroup = group
      this.deleteDocument.display = name
      this.deleteDocument.type = type
      this.deleteDocument.fiducia = fiducia
      this.deleteDocument.roya = roya

      this.showDeleteDocumentModal = true
    },

    confirmDeleteDocument() {
      this.isLoading.deleteDocument = true
      let processUrl = "/documentTemplate/delete";
      let data = new FormData();
      data.set('id', this.deleteDocument.id);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, "Delete Document sukses!")
          this.showDeleteDocumentModal = false
        } else {
          this.$helper.toastError(this, "Delete Document Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Delete Document Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Delete Document Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.deleteDocument = false

        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.getTableItems(this.table.currentPage)
        }
      })
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(this.table.currentPage)
      }
    },

    onChangeFilterType() {
      if (this.table.filterType == "type") {
        this.table.filterValue = "image"
      } else if (this.table.filterType == "fiducia" || this.table.filterType == "roya") {
        this.table.filterValue = "true"
      } else{
        this.table.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/documentTemplate/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterConfigDocumentType", this.table.filterType)
          sessionStorage.setItem("filterConfigDocumentValue", this.table.filterValue)

          this.table.items = response.data.data.data
          for (let i = 0; i < this.table.items.length; i++) {
            this.table.items[i].isSaving = false
          }
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Document Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Document Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Document Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigDocumentType"))){
      this.table.filterType = sessionStorage.getItem("filterConfigDocumentType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigDocumentValue"))){
      this.table.filterValue = sessionStorage.getItem("filterConfigDocumentValue")
    }
    this.getTableItems()

    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>